import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { Fab, Grid } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Footer from 'Components/Help/Folder/Footer';
import { ContactIcon, HelpGrid, HeroHelp, HeroTitle, ItemCard, ItemDescription, ItemTitle, SearchInput } from 'Components/Help/Help.styled';
import helpPageCards from 'Components/Help/HelpContent';
import { Link } from 'react-router-dom';

interface ItemProps {
  title: string;
  description: string;
}

export const Help = () => {

  const Item = ({ title, description }: ItemProps) => {
    return (
      <ItemCard>
        <ItemTitle>{title}</ItemTitle>
        <ItemDescription>{description}</ItemDescription>
      </ItemCard>
    );
  };

  return (
    <>
      <HeroHelp>
        <HeroTitle>How Can We Help ?</HeroTitle>
        <SearchInput>
          <TextField
            placeholder="Search for answers"
            variant="standard"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </SearchInput>
      </HeroHelp>
      <HelpGrid>
        <Grid container rowSpacing={{ xs: 4, lg: 12 }} columnSpacing={{ xs: 1, sm: 8, md: 8 }}>
          {helpPageCards.map((card, id) => (
            <Grid key={id} item xs={12} md={6} lg={4} xl={4}  >
              <Link to={card.path} style={{ textDecoration: "none" }} >
                <Item title={card.title} description={card.desc} />
              </Link>
            </Grid>
          ))}
        </Grid>
      </HelpGrid>
      <Footer />

      <ContactIcon>
        <Fab color="primary" aria-label="contact" style={{ padding: '26px 0' }}>
          <ChatOutlinedIcon />
        </Fab>
      </ContactIcon>
    </>
  );
};